import { useComponentInViewport } from 'core-lib/hooks/useComponentInViewport';
import { useEffect, useRef } from 'react';
import AnimatedImage from 'core-lib/components/AnimatedImage';
import { Typography } from 'ui-v2/components/Typography';
import { LayoutPropType } from '../../../types/layout';
import { trackSectionViewedStoreV2 } from '../../../utils/events';
import s from './ImageGridListing.module.scss';
import useStoreItemClick from '../../../hooks/useStoreItemClick';

export const ImageGridListing = ({ data }: LayoutPropType) => {
  const { handleItemClickWithDelegation } = useStoreItemClick();
  const rootRef = useRef();
  const isEventFired = useRef(false);
  const inViewPort = useComponentInViewport(rootRef, {
    threshold: 0.5,
  });
  const CARDID = data.layoutType;

  useEffect(() => {
    if (inViewPort && !isEventFired.current) {
      trackSectionViewedStoreV2(data?.title);
      isEventFired.current = true;
    }
  }, [data?.title, inViewPort]);
  return (
    <div
      className={s.root}
      ref={rootRef}
      onClick={(e) =>
        handleItemClickWithDelegation(
          e,
          CARDID,
          data?.entityType,
          data?.data,
          data?.title
        )
      }
    >
      <Typography
        label={data?.title}
        variant="h_3_medium"
        className={s.title}
      />
      {data?.metaData?.listingOrder?.map((item, ind) => (
        <div key={ind} className={s.container}>
          {data?.data
            ?.slice(
              ind > 0 ? data?.metaData?.listingOrder[ind - 1] : 0,
              ind > 0 ? item + data?.metaData?.listingOrder[ind - 1] : item
            )
            .map((card, i) => (
              <div
                key={card?.productSku}
                className={s.item}
                id={CARDID}
                data-index={i}
              >
                <AnimatedImage
                  src={card?.coverImage}
                  className={s.image}
                  alt="coverImage"
                />
                <Typography label={card?.title} variant="label_4_medium" />
              </div>
            ))}
        </div>
      ))}
    </div>
  );
};
